import { render, staticRenderFns } from "./PerduView.vue?vue&type=template&id=472b6f3a&scoped=true"
import script from "./PerduView.vue?vue&type=script&lang=js"
export * from "./PerduView.vue?vue&type=script&lang=js"
import style0 from "./PerduView.vue?vue&type=style&index=0&id=472b6f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b6f3a",
  null
  
)

export default component.exports